export const Funcs = {
    getDirectoryValue(directory, id) {
        for (let c = 0; c < directory.length; c++) {
            if (directory[c].ID === id) {
                return directory[c]
            }
        }
    }
}